import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 2rem 0;
`;
